












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { QuoteProduct } from '@/models/quote-product';
import { Quote } from '@/models/quote';
import { QuoteHistory } from '@/models/quote-history';
import { ApprovalHistory } from '@/models/approval-history';
import { Approval } from '@/models/approval';
import approvalStatusLabel from '@/components/approval-status-label.vue';
import approvalHistoryDescription from '@/components/approval-history-description.vue';
import { Permissions } from '@/models/permission-constants';

const UserModule = namespace('user');

@Component({
    components: {
        approvalStatusLabel,
        approvalHistoryDescription,
    },
})
export default class ApprovalDetails extends Vue {
    @Prop({ required: true }) public approval: Approval;
    @Prop({ required: true }) public history: Array<ApprovalHistory>;
    @UserModule.Getter public isAdmin: boolean;
    @UserModule.Getter public isSystem: boolean;
    @UserModule.Getter public canViewQuotes: boolean;
    @UserModule.Getter public canViewOrders: boolean;
    @UserModule.Getter public canViewApprovals: boolean;
    @UserModule.Getter public canApproveUpto1K: boolean;
    @UserModule.Getter public canApproveFrom1KTo5K: boolean;
    @UserModule.Getter public canApproveFrom5KTo10K: boolean;
    @UserModule.Getter public canApproveAbove10K: boolean;
    @UserModule.Getter public hasAnyPermissionId: (permissions: Array<string>) => boolean;

    public get canApproveOrReject(): boolean {
        if (this.approval.total == null) {
            return true;
        }

        const hasPermission = this.hasAnyPermissionId([this.approval.permissionId]);

        if (hasPermission || this.isAdmin || this.isSystem) {
            return true;
        }

        return false;
    }

    public acceptApprovalClicked(): void {
        this.$emit('approval-accepted', this.approval.id);
    }
    public rejectApprovalClicked(): void {
        this.$emit('approval-rejected', this.approval.id);
    }
}
